import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BookingsBase } from './Bookings'

import withSorting from 'hoc/withSorting'

import {
  bookingsWithoutBlacklistSelector,
  isLoadingSelector as hideBlacklistSelector
} from 'reduxModules/selectors/BookingSelectors'
import { blacklistPageBookingsSelector } from 'reduxModules/selectors/BlacklistSelectors'
import { isDisabledSelector } from 'reduxModules/selectors/RouteSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isDisabled: isDisabledSelector,
  bookingsWithoutBlacklist: bookingsWithoutBlacklistSelector,
  blacklistPageBookings: blacklistPageBookingsSelector,
  hideBlacklist: hideBlacklistSelector
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles),
  withSorting
)

export const Bookings = enhance(BookingsBase)



// WEBPACK FOOTER //
// ./src/components/Bookings/index.js